import React, { useState } from "react";

// import { loadStripe, Stripe } from "@stripe/stripe-js";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import Button from "../../components/Button";
import { BASE_URL } from "../../config";

// Define the expected shape of API response
interface PaymentIntentResponse {
  clientSecret: string;
}

// // Stripe options
// const options = {
//   mode: "payment",
//   amount: 1099,
//   currency: "usd",
//   appearance: {},
// };

const CheckoutForm = ({ clientSecret }: PaymentIntentResponse) => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    // Validate form inputs
    const { error: submitError } = await elements.submit();
    if (submitError) {
      setErrorMessage(submitError.message!);
      return;
    }

    // Fetch the clientSecret from the server
    try {
      const { error } = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: BASE_URL + "/dashboard/channels/onboarding/checklist",
        },
      });

      if (error) {
        setErrorMessage(error.message || "An unknown error occurred.");
      }
    } catch (error) {
      setErrorMessage(error instanceof Error ? error.message : "An error occurred.");
    }
  };

  return (
    <div className="flex flex-col gap-8">
      <PaymentElement />
      <Button to="#" onClick={handleSubmit} className="w-full md:w-auto md:min-w-[120px] formprimarybutton">
        Pay
      </Button>
      {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
    </div>
  );
};

// Load Stripe with public key
export { CheckoutForm };
